import { Controller } from "@hotwired/stimulus"

// Мост мини-приложения MAX / Telegram (эпик template-picker). Мессенджер
// передаёт initData в hash адреса: MAX — `WebAppData`, Telegram — `tgWebAppData`.
// По нему грузим ровно один мост; без него страница — витрина со ссылками в бота.
const BRIDGES = {
  telegram: { marker: "tgWebAppData", src: "https://telegram.org/js/telegram-web-app.js", app: () => window.Telegram?.WebApp },
  max: { marker: "WebAppData", src: "https://st.max.ru/js/max-web-app.js", app: () => window.WebApp }
}
const FORBIDDEN_TEXT = "Окно устарело. Откройте его заново из бота."
const FAILED_TEXT = "Не получилось. Попробуйте ещё раз."

export default class extends Controller {
  static values = { pickUrl: String, commandUrl: String }

  connect() {
    // Telegram первым: `tgWebAppData` содержит и подстроку `WebAppData`.
    const name = Object.keys(BRIDGES).find((key) => location.hash.includes(BRIDGES[key].marker))
    if (!name) return

    const script = document.createElement("script")
    script.src = BRIDGES[name].src
    script.onload = () => {
      const app = BRIDGES[name].app()
      if (!app?.initData) return

      this.provider = name
      this.app = app
      document.documentElement.classList.add("is-app")
      app.ready?.()
      app.expand?.()
    }
    document.head.appendChild(script)
  }

  open({ params: { dialog } }) {
    document.getElementById(dialog)?.showModal()
  }

  dismiss(event) {
    event.target.closest("dialog")?.close()
  }

  // Клик мимо содержимого — по самому <dialog>, то есть по подложке.
  backdrop(event) {
    if (event.target === event.currentTarget) event.currentTarget.close()
  }

  pick(event) {
    const button = event.currentTarget
    this.send(button, button.closest("dialog"), this.pickUrlValue, { template_id: event.params.template })
  }

  // Кнопки команд над образцами: экран приходит в чат, окно закрывается.
  command(event) {
    const button = event.currentTarget
    this.send(button, button.closest(".ma-nav"), this.commandUrlValue, { command: event.params.command })
  }

  async send(button, box, url, body) {
    const error = box.querySelector(".ma-error")
    button.disabled = true
    error.hidden = true

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ provider: this.provider, init_data: this.app.initData, ...body })
      })
      if (response.ok) return this.app.close()

      error.textContent = response.status === 403 ? FORBIDDEN_TEXT : FAILED_TEXT
    } catch {
      error.textContent = FAILED_TEXT
    }
    error.hidden = false
    button.disabled = false
  }
}
